module.exports = __webpack_public_path__ + "static/media/abrakadabra.3bed696b.mp3";